module.exports = __webpack_public_path__ + "static/media/history-timer.133291ea.svg";